import React from "react";
import style from "./style.module.scss";
import { ReactComponent as DownloadIcon } from "../../assets/download.svg";
import useMeasure from 'react-use-measure';
import { ResizeObserver } from '@juggle/resize-observer';



export default function Button({height=null, Icon, classIcon, href, children, external = false, disabled = false, textColor, rel = "", ...props}){
    const classNames = style.sharedButton + (props.className ? " " + props.className : "");
    const classColorText = style.link_text + " " + (textColor ? textColor : style.whiteText);
    const [ref, bounds] = useMeasure({ polyfill: ResizeObserver });
    if(external && rel === "") {
        rel = "noopener noreferrer";
    }
    if(disabled) {
        props.onClick = () => false;
    }
    return <a {...props} href={href} className={classNames} {...(external ? {target: "_blank", rel} : {})}>
        <div className={style.link_icon} style={{"height":height ? height : bounds.height}} >{
            Icon ? <Icon className={classIcon} /> : <DownloadIcon className={classIcon} />
        } </div>
        <div className={classColorText} style={{"height":height ? height : "unset"}} ref={ref}>{children}</div>
    </a>
}
